import { useState } from 'preact/hooks';
import Button from '../../components/shared/Button/Button';
import IconButton from '../../components/shared/IconButton/IconButton';
import useTranslation from '../../localization/i18n.context';
import CheckBox from '../../components/shared/CheckBox/CheckBox';
import RadioButton from '../../components/shared/RadioButton/RadioButton';
import Switch from '../../components/shared/Switch/Switch';
import TextField from '../../components/shared/TextField/TextField';
import Alert from '../../components/shared/Alert/Alert';
import BottomSheet from '../../components/shared/BottomSheet/BottomSheet';
import List from '../../components/shared/List/List';
import ListItem from '../../components/shared/List/ListItem';
import Tooltip from '../../components/shared/Tooltip/Tooltip';
import NumberInput from '../../components/shared/NumberInput/NumberInput';
import AddIcon from '../../components/shared/Icons/AddIcon';
import CardIcon from '../../components/shared/Icons/CardIcon';
import Title from '../../components/shared/Typography/Title';
import BodyText from '../../components/shared/Typography/BodyText';
import SelectBox from '../../components/shared/SelectBox/SelectBox';
import Popup from '../../components/shared/Popup/Popup';
import ErrorSqaure from '../../assets/images/error-round.webp';
import Skeleton from '../../components/shared/Skeleton/Skeleton';
import AppBar from '../../components/shared/AppBar/AppBar';
import Toast from '../../components/shared/Toast/Toast';
import SearchBox from '../../components/shared/SearchBox/SearchBox';
import BulletRow from '../../components/shared/BulletRow/BulletRow';
import Carousel from '../../components/shared/Carousel/Carousel';
import InlineMessage from '../../components/shared/InlineMessage/InlineMessage';

export default function StoryBoardPage() {
  const { t } = useTranslation();
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [fullScreenSheet, setSullScreenSheet] = useState(false);
  const [selectedValue, setSelectedValue] = useState('Option 2');
  const [numberInput, setNumberInput] = useState('123');

  const onButtonClick = () => {
    alert('clicked');
  };
  const carouselItems = [
    <Alert
      message="Lorem ipsum dolor sit amet"
      type={Alert.Type.INFO}
      size={Alert.Size.COMPACT}
      hasIcon
      hasButton
      buttonText={t('button')}
      onButtonClick={onButtonClick}
    />,
    <Alert
      message="Lorem ipsum dolor sit amet"
      type={Alert.Type.WARNING}
      hasIcon
      hasButton
      buttonText={t('button')}
      onButtonClick={onButtonClick}
    />,
    <Alert
      message="Lorem ipsum dolor sit amet"
      type={Alert.Type.MARKETING}
      hasIcon
      hasButton
      buttonText={t('button')}
    />,
  ];
  return (
    <main>
      <AppBar
        title="Components"
        onCloseClick={() => {
          alert('close clicked');
        }}
        onBackClick={() => {
          alert('back clicked');
        }}
      />
      <Title text="CaaS project UI Kit" />
      <BodyText text="Enter the last 4 four digits of the number on the back of your phyisical Lucky One card" />
      <div className="demo">
        <SearchBox placeholder={t('Search')} />
      </div>
      <div className="demo">Buttons</div>
      <div className="demo">
        <Button> {t('button')}</Button> <Button disabled>{t('button')}</Button>
        <Button size={Button.Size.SMALL}>{t('button')}</Button>
      </div>

      <div className="demo">
        <Button type={Button.Type.SECONDARY}>{t('button')}</Button>
        <Button type={Button.Type.SECONDARY} disabled>
          {t('button')}
        </Button>
        <Button type={Button.Type.SECONDARY} size={Button.Size.SMALL}>
          {t('button')}
        </Button>
      </div>

      <div className="demo">
        <Button type={Button.Type.TERTIARY}>{t('button')}</Button>
        <Button type={Button.Type.TERTIARY} disabled>
          {t('button')}
        </Button>
        <Button type={Button.Type.TERTIARY} size={Button.Size.SMALL}>
          {t('button')}
        </Button>
      </div>

      <div className="demo">
        <Button fullWidth>{t('button')}</Button>
      </div>
      <div className="demo">
        <Button type={Button.Type.SECONDARY} fullWidth>
          {t('button')}
        </Button>
      </div>
      <div className="demo">
        <Button type={Button.Type.TERTIARY} fullWidth>
          {t('button')}
        </Button>
      </div>

      <div className="demo">Icon Buttons</div>

      <div className="demo">
        <IconButton text={t('button')} icon={<AddIcon />}></IconButton>
        <IconButton text={t('button')} icon={<AddIcon />} disabled></IconButton>
        <IconButton
          text={t('button')}
          type={IconButton.Type.SECONDARY}
          icon={<AddIcon />}
        ></IconButton>
        <IconButton
          text={t('button')}
          type={IconButton.Type.SECONDARY}
          icon={<AddIcon />}
          disabled
        ></IconButton>
      </div>

      <div className="demo">Controls</div>

      <div className="demo">
        <RadioButton name="radio" checked />
        <RadioButton name="radio" />
        <RadioButton name="radio1" checked disabled />
        <RadioButton name="radio1" disabled />
      </div>

      <div className="demo">
        <CheckBox checked />
        <CheckBox />
        <CheckBox checked disabled />
        <CheckBox disabled />
      </div>

      <div className="demo">
        <Switch checked />
        <Switch />
        <Switch checked disabled />
        <Switch disabled />
      </div>
      <div className="demo">Alerts</div>
      <div className="demo">
        <Alert
          message={t('alert-text')}
          type={Alert.Type.INFO}
          hasIcon
          hasButton
          buttonText={t('button')}
          onButtonClick={onButtonClick}
        />
      </div>
      <div className="demo">
        <Alert
          message={t('alert-text')}
          type={Alert.Type.WARNING}
          hasIcon
          hasButton
          buttonText={t('button')}
          onButtonClick={onButtonClick}
        />
      </div>
      <div className="demo">
        <Alert
          message={t('alert-text')}
          type={Alert.Type.SUCCESS}
          hasIcon
          hasButton
          buttonText={t('button')}
          onButtonClick={onButtonClick}
        />
      </div>
      <div className="demo">
        <Alert
          message={t('alert-text')}
          type={Alert.Type.ERROR}
          hasIcon
          hasButton
          buttonText={t('button')}
          onButtonClick={onButtonClick}
        />
      </div>

      <div className="demo">
        <Alert
          message={t('alert-text')}
          type={Alert.Type.INFO}
          size={Alert.Size.COMPACT}
          hasButton
          buttonText={t('button')}
          onButtonClick={onButtonClick}
        />
      </div>
      <div className="demo">
        <Alert
          message={t('alert-text')}
          type={Alert.Type.WARNING}
          size={Alert.Size.COMPACT}
          hasButton
          buttonText={t('button')}
          onButtonClick={onButtonClick}
        />
      </div>
      <div className="demo">
        <Alert
          message={t('alert-text')}
          type={Alert.Type.SUCCESS}
          size={Alert.Size.COMPACT}
          hasButton
          buttonText={t('button')}
          onButtonClick={onButtonClick}
        />
      </div>
      <div className="demo">
        <Alert
          message={t('alert-text')}
          type={Alert.Type.ERROR}
          size={Alert.Size.COMPACT}
          hasButton
          buttonText={t('button')}
          onButtonClick={onButtonClick}
        />
      </div>

      <div className="demo">
        <Alert message={t('alert-text')} type={Alert.Type.INFO} hasIcon />
      </div>
      <div className="demo">
        <Alert message={t('alert-text')} type={Alert.Type.WARNING} hasIcon />
      </div>
      <div className="demo">
        <Alert message={t('alert-text')} type={Alert.Type.SUCCESS} hasIcon />
      </div>
      <div className="demo">
        <Alert message={t('alert-text')} type={Alert.Type.ERROR} hasIcon />
      </div>

      <div className="demo">List</div>
      <div className="demo">
        <List>
          <ListItem
            title="Title (1 line) With long title just to see how it loks"
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
          />
          <ListItem
            title="Title (1 line)"
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
            actionable
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
          />

          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
            disabled
            actionable
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            selected
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
            type={ListItem.Type.RADIO}
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            disabled
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
            type={ListItem.Type.RADIO}
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            disabled
            selected
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
            type={ListItem.Type.RADIO}
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            type={ListItem.Type.RADIO}
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            selected
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
            type={ListItem.Type.CHECKBOX}
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            disabled
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
            type={ListItem.Type.CHECKBOX}
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            disabled
            selected
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
            type={ListItem.Type.CHECKBOX}
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            type={ListItem.Type.CHECKBOX}
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            selected
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
            type={ListItem.Type.SWITCH}
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            disabled
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
            type={ListItem.Type.SWITCH}
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            disabled
            selected
            icon={
              <CardIcon height={24} width={24} style={{ padding: '8px' }} />
            }
            type={ListItem.Type.SWITCH}
          />
          <ListItem
            title="Title (1 line)"
            subtitle="Subtitle (up to 2 lines)"
            actionable
            type={ListItem.Type.SWITCH}
          />
        </List>
      </div>
      <div className="demo">Tooltip</div>

      <div className="demo">
        <Tooltip content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.">
          <Button size={Button.Size.SMALL}>{t('button')}</Button>
        </Tooltip>
        <Tooltip content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.">
          <Button size={Button.Size.SMALL}>{t('button')}</Button>
        </Tooltip>

        <Tooltip content="Lorem ipsum dolor sit amet">
          <Button size={Button.Size.SMALL}>{t('button')}</Button>
        </Tooltip>
        <Tooltip content="Lorem ipsum dolor sit amet">
          <Button size={Button.Size.SMALL}>{t('button')}</Button>
        </Tooltip>
      </div>

      <div className="demo">
        <Tooltip
          content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
          position={Tooltip.Position.TOP}
        >
          <Button size={Button.Size.SMALL}>{t('button')}</Button>
        </Tooltip>
        <Tooltip
          content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
          position={Tooltip.Position.TOP}
        >
          <Button size={Button.Size.SMALL}>{t('button')}</Button>
        </Tooltip>

        <Tooltip
          content="Lorem ipsum dolor sit amet"
          position={Tooltip.Position.TOP}
        >
          <Button size={Button.Size.SMALL}>{t('button')}</Button>
        </Tooltip>
        <Tooltip
          content="Lorem ipsum dolor sit amet"
          position={Tooltip.Position.TOP}
        >
          <Button size={Button.Size.SMALL}>{t('button')}</Button>
        </Tooltip>
      </div>
      <div className="demo">Forms</div>
      <div className="demo">
        <TextField label={t('label')} helperText="Helper Text" />
      </div>
      <div className="demo">
        <TextField
          label={t('label')}
          placeholder="Hint"
          helperText="Helper Text"
        />
      </div>
      <div className="demo">
        <TextField
          label={t('label')}
          hasError
          placeholder="Hint"
          helperText="Helper Text"
          value={'asd'}
        />
      </div>

      <div className="demo">
        <TextField
          label={t('label')}
          disabled
          placeholder="Hint"
          helperText="Helper Text"
          value={'disabled'}
        />
      </div>

      <div className="demo">
        <NumberInput helperText="Helper Text" />
      </div>
      <div className="demo">
        <NumberInput helperText="Helper Text" hasError />
      </div>

      <div className="demo">
        <NumberInput helperText="Helper Text" disabled />
      </div>
      <div className="demo">
        <NumberInput
          helperText="Helper Text"
          length={4}
          value="123"
          onChange={value => {
            setNumberInput(value);
          }}
        />
      </div>
      <div className="demo">
        <NumberInput
          helperText="Helper Text"
          length={4}
          value={numberInput}
          masked
          onChange={value => {
            setNumberInput(value);
          }}
        />
      </div>
      <div className="demo">
        <NumberInput helperText="Helper Text" length={3} />
      </div>

      <div className="demo">
        <div>{selectedValue}</div>
      </div>
      <div className="demo">
        <SelectBox
          label={t('label')}
          title={t('label')}
          placeholder="Hint"
          name="first-select"
          helperText="Helper Text"
          options={['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5']}
          value={selectedValue}
          onChange={setSelectedValue}
        />
      </div>
      <div className="demo">
        <SelectBox
          label={t('label')}
          title={t('label')}
          name="second-select"
          helperText="Helper Text"
          options={['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5']}
          onChange={setSelectedValue}
        />
      </div>
      <div className="demo">
        <SelectBox
          label={t('label')}
          title={t('label')}
          placeholder="Hint"
          helperText="Helper Text"
          name="error-select"
          hasError
          options={['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5']}
        />
      </div>

      <div className="demo">
        <SelectBox
          label={t('label')}
          title={t('label')}
          placeholder="Hint"
          helperText="Helper Text"
          name="disabled-select"
          disabled
          options={['Option 1', 'Option 2', 'Option 3', 'Option 4', 'Option 5']}
        />
      </div>

      <div className="demo">Bottom Sheet</div>
      <div className="demo">
        <Button
          onClick={() => {
            setShowBottomSheet(true);
          }}
        >
          {t('Show sheet')}
        </Button>

        <Button
          onClick={() => {
            setShowBottomSheet(true);
            setSullScreenSheet(true);
          }}
        >
          {t('Show sheet full screen')}
        </Button>

        {showBottomSheet && (
          <BottomSheet
            title="title"
            onBackClick={console.log}
            onCloseClick={() => {
              setShowBottomSheet(false);
              setSullScreenSheet(false);
            }}
            footerActions={<Button fullWidth>{t('button')}</Button>}
            fullScreen={fullScreenSheet}
          >
            <div className="demo">
              <Alert
                message={t('alert-text')}
                type={Alert.Type.ERROR}
                hasIcon
              />
            </div>
            <div className="demo">
              <Alert
                message={t('alert-text')}
                type={Alert.Type.ERROR}
                hasIcon
              />
            </div>
            <div className="demo">
              <Alert
                message={t('alert-text')}
                type={Alert.Type.ERROR}
                hasIcon
              />
            </div>
            <div className="demo">
              <Alert
                message={t('alert-text')}
                type={Alert.Type.ERROR}
                hasIcon
              />
            </div>
            <div className="demo">
              <Alert
                message={t('alert-text')}
                type={Alert.Type.ERROR}
                hasIcon
              />
            </div>
            <div className="demo">
              <Alert
                message={t('alert-text')}
                type={Alert.Type.ERROR}
                hasIcon
              />
            </div>
            <div className="demo">
              <Alert
                message={t('alert-text')}
                type={Alert.Type.ERROR}
                hasIcon
              />
            </div>
            <div className="demo">
              <Alert
                message={t('alert-text')}
                type={Alert.Type.ERROR}
                hasIcon
              />
            </div>
            <div className="demo">
              <Alert
                message={t('alert-text')}
                type={Alert.Type.ERROR}
                hasIcon
              />
            </div>
            <div className="demo">
              <Alert
                message={t('alert-text')}
                type={Alert.Type.ERROR}
                hasIcon
              />
            </div>
          </BottomSheet>
        )}
      </div>

      <div className="demo">Popup</div>
      <div className="demo">
        <Button
          onClick={() => {
            setShowPopup(true);
          }}
        >
          {t('Show popup')}
        </Button>

        <Popup
          title="Title or question (up to 3 lines)"
          subtitle="Here we can add a subtitle or disclaimer if necessary."
          icon={ErrorSqaure}
          showing={showPopup}
          primaryCta={{
            text: 'Call to action',
            onClick: () => {
              alert('main cta clicked');
              setShowPopup(false);
            },
          }}
          secondaryCta={{
            text: 'secondary cta',
            onClick: () => {
              alert('secondary cta clicked');
              setShowPopup(false);
            },
          }}
          onCloseClick={() => {
            setShowPopup(false);
          }}
        />
      </div>
      <div className="demo">Skeleton</div>
      <div className="demo">
        <Skeleton width={200} height={200} radius={200} />
      </div>
      <div className="demo">
        <Skeleton width={300} height={40} radius={16} />
      </div>
      <div className="demo">
        <Skeleton />
      </div>

      <div className="demo">Toasts</div>
      <div className="demo">
        <Toast
          message={'Lorem ipsum dolor sit'}
          type={Toast.Type.INFO}
          buttonText={t('button')}
          onButtonClick={onButtonClick}
          onCloseClick={() => {
            alert('close clicked');
          }}
          showing={true}
        />
      </div>
      <div className="demo">
        <Toast
          message={'Lorem ipsum dolor sit'}
          type={Toast.Type.WARNING}
          buttonText={t('button')}
          onButtonClick={onButtonClick}
          onCloseClick={() => {
            alert('close clicked');
          }}
          showing={true}
        />
      </div>
      <div className="demo">
        <Toast
          message={'Lorem ipsum dolor sit'}
          type={Toast.Type.SUCCESS}
          buttonText={t('button')}
          onButtonClick={onButtonClick}
          onCloseClick={() => {
            alert('close clicked');
          }}
          showing={true}
        />
      </div>
      <div className="demo">
        <Toast
          message={'Lorem ipsum dolor sit'}
          type={Toast.Type.ERROR}
          buttonText={t('button')}
          onButtonClick={onButtonClick}
          onCloseClick={() => {
            alert('close clicked');
          }}
          showing={true}
        />
      </div>
      <div className="demo">Bullet Rows</div>
      <div className="demo">
        <BulletRow
          title="Title"
          subtitle="Subtitle"
          icon={<CardIcon height={24} width={24} />}
        />
      </div>
      <div className="demo">
        <BulletRow title={t('Next payment')} subtitle="EGP 120.00" />
      </div>
      <div className="demo">
        <BulletRow
          type={BulletRow.Type.ERROR}
          title={t('Next payment due date')}
          subtitle="15/02/2021"
        />
      </div>
      <div className="demo">Carousel Alerts</div>
      <div className="demo">
        <Carousel items={carouselItems} />
      </div>
      <div className="demo">Inline Message</div>
      <div className="demo">
        <InlineMessage
          textKey="Merchant ID is:"
          textValue="123456789"
          hasIcon
        />
      </div>
      <div className="demo">
        <InlineMessage textKey="Merchant ID is:" textValue="123456789" />
      </div>
    </main>
  );
}
